<template>
  <div
    :id="item.key"
    class="m-image-element mb-10"
  >
    <base-image
      v-if="item.image && item.image[0]"
      :url="item.image[0].url"
      :width="909"
      :height="390"
      :alt-text="item.imageAltText"
      image-class="m-image-element__image"
    />
  </div>
</template>

<script>
import BaseImage from '@/components/atoms/BaseImage';

export default {
  name: 'ImageElement',
  components: {
    BaseImage
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
};
</script>
